import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db, googleProvider } from '../firebase/firebase';
import { signInWithPopup } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { Container, Card, Button, Alert, Spinner } from 'react-bootstrap';

const LoginForm = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {
      setLoading(true);
      setError('');

      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      // Log token for testing
      const token = await user.getIdToken();
      console.log('Firebase ID Token:', token);
      console.log('User ID:', user.uid);

      // Check if user exists
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      
      if (userDoc.exists()) {
        // Existing user - go to home
        navigate('/home');
      } else {
        // New user - go to role selection
        navigate('/role-selection');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 bg-light d-flex align-items-center">
      <Container className="py-5">
        <div className="mx-auto" style={{ maxWidth: '400px' }}>
          <Card>
            <Card.Body className="p-4">
              {error && (
                <Alert variant="danger">
                  {error}
                </Alert>
              )}
              
              <h2 className="text-center mb-4">Welcome to Scheduler</h2>
              
              <Button
                variant="primary"
                className="w-100"
                onClick={handleGoogleLogin}
                disabled={loading}
              >
                {loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                ) : null}
                {loading ? 'Processing...' : 'Sign in with Google'}
              </Button>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default LoginForm;